import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { routers } from './router'

Vue.use(Router)

const routerConfig = {
  mode: 'history',
  base: '/pm/',
  routes: routers
}
const router = new Router(routerConfig)
router.beforeEach((to, form, next) => {
  if (location.host.indexOf('pm.xb969.com') >= 0) {
    let ishttps = document.location.protocol == 'https:'
    if (!ishttps) {
      let httpUrl = document.location + ''
      let str = httpUrl.split('http://')
      window.location.href = 'https://' + str[1]
    }
  }

  document.title = to.meta.title || '加西亚'
  if (store.state.user) {
    next()
  } else {
    if (to.path == '/login') {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

router.afterEach((to, from) => {
  window.scrollTo(0, 50)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js